import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { StyledTableCell } from "../../../components/ShipmentSummary/components/SummaryGrid/SummaryGrid";
import { TABLE_BORDER_GRAY } from "../../../constants/css.constants";
import { formatNumbersWithCommas } from "../../../constants/utils";

const FIRST_COLUMNS = {
  currentSummary: " Current Forecast",
  previousSummary: "Previous Forecast",
  variance: "Variance",
  variancePercent: "Variance %",
};
export type Forecast = {
  currentSummary: string;
  date: string;
  previousSummary: string;
  variance: string;
  variancePercent: string;
};

type PlanningTableProps = {
  forecasts: Forecast[];
};
export default function SummaryShipmentTable({
  forecasts,
}: PlanningTableProps) {
  const createRow = (
    rows: Forecast[],
    accessor: keyof Forecast,
    parentRow: number,
  ) => (
    <TableRow
      sx={{
        color: "#fff",
      }}
    >
      <StyledTableCell
        index={0}
        cssProperties={{
          whiteSpace: "nowrap",
        }}
      >
        {FIRST_COLUMNS[accessor]}
      </StyledTableCell>
      {rows.map((row, i) => (
        <StyledTableCell key={`${row[accessor]}-${i}`} scope="row" index={i}>
          {parentRow < 3
            ? formatNumbersWithCommas(row[accessor])
            : `${parseFloat(row[accessor]).toFixed(1)}%`}
        </StyledTableCell>
      ))}
    </TableRow>
  );
  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          minWidth: 650,
          backgroundColor: "rgb(39, 41, 61)",
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <StyledTableCell
              index={0}
              cssProperties={{ borderTop: TABLE_BORDER_GRAY }}
            >
              Forecast
            </StyledTableCell>
            {forecasts.map((row) => (
              <StyledTableCell
                key={row.date}
                scope="row"
                cssProperties={{
                  minWidth: "95px",
                  borderTop: TABLE_BORDER_GRAY,
                  whiteSpace: "nowrap",
                }}
              >
                {row.date
                  .split(" ")
                  .map((string, i) =>
                    i === 0 ? string.substring(0, 3) : string,
                  )
                  .join(" ")}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {createRow(forecasts, "currentSummary", 0)}
          {createRow(forecasts, "previousSummary", 1)}
          {createRow(forecasts, "variance", 2)}
          {createRow(forecasts, "variancePercent", 3)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
